/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const questions = [
    {
        id: 'is-enter-date-between-may-sep',
        description:
            'Are you entering the Boundary Waters Canoe Area Wilderness (BWCAW) between May 1 and September 30?',
        type: 'single-choice-radio',
        choices: [
            {
                description: 'Yes',
                value: 'yes',
            },
            {
                description: 'No',
                value: 'no',
            },
        ],
    },
    {
        id: 'choose-activity',
        description: 'What type of activity will you be doing?',
        type: 'single-choice-radio',
        choices: [
            {
                description: 'Paddling only (non-motorized), staying overnight in BWCAW.',
                value: 'paddle-overnight',
            },
            {
                description:
                    'Paddling or hiking (non-motorized), but not spending the night in BWCAW.',
                value: 'hike-paddle-day',
            },
            {
                description: 'Hiking only (no watercraft), staying overnight in BWCAW.',
                value: 'hike-overnight',
            },
            {
                description:
                    'Using motorized watercraft (for any portion of the trip and applies to all watercraft). Day Use Motor or Overnight Motor Permit is required.',
                value: 'motor',
            },
        ],
    },
    {
        id: 'is-canada-visit',
        description: 'Are you going to or from Canada on this trip?',
        type: 'single-choice-radio',
        choices: [
            {
                description: 'No',
                value: 'no',
            },
            {
                description: 'Yes',
                value: 'yes',
            },
        ],
    },
    {
        id: 'is-overnight-stay',
        description: 'Are you staying overnight?',
        type: 'single-choice-radio',
        choices: [
            {
                description: 'No',
                value: 'no',
            },
            {
                description: 'Yes',
                value: 'yes',
            },
        ],
    },
    {
        id: 'is-overnight-visit',
        description: 'Will you be spending any nights in BWCAW?',
        type: 'single-choice-radio',
        choices: [
            {
                description: 'Yes',
                value: 'yes',
            },
            {
                description: 'No',
                value: 'no',
            },
        ],
    },
    {
        id: 'choose-canada-trip-description-motor',
        description: 'What best describes your trip? ',
        type: 'single-choice-radio',
        choices: [
            {
                description: 'Day visit, not staying overnight in Canada or BWCAW',
                value: 'day-visit',
            },
            {
                description: 'Overnight trip, starting in Canada and visiting BWCAW',
                value: 'overnight-from-canada',
            },
            {
                description: 'Overnight trip, starting in BWCAW and visiting Canada',
                value: 'overnight-from-bwcaw-to-canada',
            },
        ],
    },
    {
        id: 'choose-trip-description-paddle',
        description: 'What best describes your trip? ',
        type: 'single-choice-radio',
        choices: [
            {
                description: 'Not visiting Canada',
                value: 'no-canada-visit',
            },
            {
                description: 'Starting in Canada and staying overnight in BWCAW',
                value: 'from-canada-overnight',
            },
            {
                description:
                    'Starting in BWCAW traveling to Canada and re-entering the BWCAW.',
                value: 'from-bwcaw-to-canada-and-back',
            },
        ],
    },
];

export const questionnaire = {
    'is-enter-date-between-may-sep': {
        yes: {
            'choose-activity': {
                'hike-paddle-day': {
                    result: 'self-issued',
                },
                'hike-overnight': {
                    result: 'overnight-hike',
                },
                'paddle-overnight': {
                    'choose-trip-description-paddle': {
                        'no-canada-visit': {
                            result: 'overnight-paddle',
                        },
                        'from-canada-overnight': {
                            result: 'overnight-paddle-entry-71',
                        },
                        'from-bwcaw-to-canada-and-back': {
                            result: 'overnight-paddle-canada',
                        },
                    },
                },
                motor: {
                    'is-canada-visit': {
                        no: {
                            'is-overnight-visit': {
                                yes: {
                                    result: 'overnight-motor',
                                },
                                no: {
                                    result: 'day-use-motor',
                                },
                            },
                        },
                        yes: {
                            'choose-canada-trip-description-motor': {
                                'day-visit': {
                                    result: 'day-use-motor',
                                },
                                'overnight-from-canada': {
                                    'is-overnight-visit': {
                                        yes: {
                                            result: 'overnight-motor-entry-71',
                                        },
                                        no: {
                                            result: 'day-use-motor-to-canada',
                                        },
                                    },
                                },
                                'overnight-from-bwcaw-to-canada': {
                                    'is-overnight-visit': {
                                        yes: {
                                            result: 'overnight-motor-canada',
                                        },
                                        no: {
                                            result: 'day-use-motor-to-canada',
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
        no: {
            result: 'self-issued',
        },
    },
};

// convert questions to questions by id
export function getQuestionsById(qs) {
    const ret = {};
    qs.forEach((q) => {
        ret[q.id] = q;
    });
    return ret;
}

// convert answers to answers by question id
export function getAnswersById(answers) {
    const ret = {};
    answers.forEach((a) => {
        ret[a.id] = a;
    });
    return ret;
}

// convert choices to choices by value
export function getChoicesByValue(choices) {
    const ret = {};
    choices.forEach((c) => {
        ret[c.value] = c;
    });
    return ret;
}

// find next question in questionnaire tree relative to current question and answers
export function getNextQuestion(currentQuestion, answers) {
    let questionId = Object.keys(questionnaire)[0]; // root/first question
    const answersById = getAnswersById(answers);
    const questionsById = getQuestionsById(questions);
    if (!currentQuestion) {
        // return first question
        return questionsById[questionId];
    }
    // parse questionnaire tree and find next question relative to current given answers
    let followUpChoices = questionnaire[questionId];
    let followUpQuestion = null;
    let foundCurrentQuestion = false;
    while (true) {
        if (followUpChoices.result) {
            // if next choice is a result, then return it
            return followUpChoices.result;
        }
        if (currentQuestion.id === questionId) {
            foundCurrentQuestion = true;
        }
        const answer = answersById[questionId];
        if (!answer) {
            // if no answer to current question, then return current question from tree
            return questionsById[questionId];
        }
        // find follow up question
        let alreadyAnswered = false;
        for (const choice in followUpChoices) {
            if (answer.value === choice) {
                followUpQuestion = followUpChoices[choice];
                alreadyAnswered = true;
                break;
            }
        }
        if (!alreadyAnswered) {
            // if question was not answered then return it, regardless of currentQuestion
            return questionsById[questionId];
        }
        if (followUpQuestion.result) {
            // if next question is an end result, then return it
            return followUpQuestion.result;
        }
        questionId = Object.keys(followUpQuestion)[0];
        if (foundCurrentQuestion) {
            // found next question then return it
            return questionsById[questionId];
        }
        followUpChoices = followUpQuestion[questionId];
    }
}
